"use client";

import { Facebook, Linkedin, Twitter } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FooterSection() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  const currentYear = new Date().getFullYear();
  return <footer ref={ref} className={`bg-dark-background text-foreground-dark transition-opacity duration-[var(--duration-medium)] ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="container mx-auto px-6 py-6">
        <div className="flex flex-col items-center justify-between gap-4 sm:flex-row">
          <p className="text-sm text-foreground-dark/80">
            © {currentYear} Vokse Global Consulting. Todos los derechos
            reservados.
          </p>

          
        </div>
      </div>
    </footer>;
}